<template>
  <withTopNav
    :leftText="$t('meu.Deposit')"
    class="text-13"
    :onClickLeft="
      () => {
        $router.back();
      }
    "
    fixed
  >
    <div class="DepositoQRcode flex flex-col h-full">
      <div class="flex-1 flex flex-col overflow-y-auto">
        <div class="flex items-center justify-center py-4">
          <Image :src="pixq" alt="" class="h-[44px]" />
        </div>
        <div class="flex items-center justify-center">
          <ul class="text-white text-sm msgList w-[90%]">
            <li class="mt-4">
              {{ $t('DepositoQRcode.ScanningTutorial') }}
            </li>
            <li class="mt-4">
              {{ $t('DepositoQRcode.QRCodeTimesDescription') }}
            </li>
          </ul>
        </div>
        <div
          class="flex items-center justify-center mt-4 text-[#FFDF12] text-[18px] pt-3"
        >
          <span class="mr-1">{{ formatter().format(amount || 0) }}BRL</span>
          <img
            :src="iCount"
            alt=""
            class="w-[24px]"
            @click="copyText(formatter().format(amount || 0))"
          />
        </div>
        <div class="flex items-center justify-center mt-4">
          <div
            class="bg-white rounded-[10px] flex items-center justify-center"
            style="width: 160px; height: 160px"
          >
            <qrcode :value="qrCode" level="H" :size="120" />
          </div>
        </div>
        <div
          v-if="isExpired(createTime)"
          class="text-[#fff] flex items-center justify-center mt-4"
        >
          {{ $t('DepositoQRcode.ExpirationReminder') }}
        </div>

        <div class="mt-5 flex items-center justify-center">
          <div
            @click="copyText(qrCode)"
            class="flex items-center justify-center bg-[#64F765] w-[242px] h-[44px] p-2 rounded-[10px] text-center text-[#2F1780] font-bold"
          >
            <span class="inline-block mr-2 text-[18px] text-[#151A1F]"
              >{{ $t('DepositoQRcode.CopyQRcode') }}</span
            >
            <Image :src="biCount" alt="" class="w-[24px]" />
          </div>
        </div>
        <div class="mt-4 flex items-center justify-center">
          <span class="mr-1"> {{ $t('DepositoQRcode.QRcodeAddress') }}{{ qrCode.slice(-8) }} </span>
          <Image :src="iCount" alt="" class="w-[24px]" @click="copyText(qrCode)" />
        </div>
        <div
          class="table w-[90%] mx-auto text-[13px] border-spacing-[2px] border-separate overflow-hidden rounded-[14px] mt-4"
        >
          <div class="table-row bg-[#2C7952]/15">
            <span class="table-cell w-[300px] text-[#fff]/75 p-2 align-middle">
              {{ $t('DepositoQRcode.CreationDate') }}
            </span>
            <span
              class="table-cell w-3/5 text-[#fffcd1] break-words text-sm p-2 align-middle"
            >
              <div class="flex justify-between items-center">
                <span class="break-words grow-0 w-4/5 text-[12px] text-[#fff]">
                  {{ dayjs(createTime).format("DD-MM-YYYY HH:mm:ss") }}
                </span>
                <img
                  :src="iCount"
                  alt=""
                  class="w-[24px] h-[24px]"
                  @click="copyText(dayjs(createTime).format('DD-MM-YYYY HH:mm:ss'))"
                />
              </div>
            </span>
          </div>

          <div class="table-row bg-[#2C7952]/10">
            <span class="table-cell w-2/5 text-[#fff]/75 p-2 align-middle">
              {{ $t('DepositoQRcode.PaymentOrderNumber') }}
            </span>
            <span
              class="table-cell text-[#fffcd1] break-words text-sm p-2 align-middle break-all"
            >
              <div class="flex justify-between items-center">
                <div class="break-words grow-0 w-4/5 text-[12px] text-[#fff]">
                  {{ orderNo }}
                </div>
                <img
                  :src="iCount"
                  alt=""
                  class="w-[24px] h-[24px]"
                  @click="copyText(orderNo)"
                />
              </div>
            </span>
          </div>

          <div class="table-row bg-[#2C7952]/15">
            <span class="table-cell w-2/5 text-[#fff]/75 p-2 align-middle">
              {{ $t('DepositoQRcode.MerchantOrderNumber') }}
            </span>
            <span class="table-cell text-[#fffcd1] break-words text-sm p-2 align-middle">
              <div class="flex justify-between items-center">
                <span class="break-words grow-0 w-4/5 text-[12px] text-[#fff]">{{
                  merchantOrderNo
                }}</span>
                <img
                  :src="iCount"
                  alt=""
                  class="w-[24px] h-[24px]"
                  @click="copyText(merchantOrderNo)"
                />
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </withTopNav>
</template>

<script setup lang="ts">
import { formatter, copyText } from "@/utils";
import pixq from "@/themes/theme_a/views/DepositoQRcode/images/pixq.png";
import iCount from "@/themes/theme_a/views/DepositoQRcode/images/iCount.png";
import biCount from "@/themes/theme_a/views/DepositoQRcode/images/biCount.png";
import qrcode from "qrcode.vue";
import withTopNav from "@/layouts/withTopNav.vue";
import dayjs from "dayjs";
import { checkingOrder } from "@/api/deposito";
// import useTrack from "@/hooks/useTrack";
// const { track2Platform, trackName } = useTrack();
// import { useWallet } from "@/store";

const router = useRouter();
const route = useRoute();
const searchParams: any = route.query;
// const initData = {
//   merchantOrderNo: "RO1841431691861872640", // 自己的order id
//   orderNo: "WD1727866503446M1727338282RK9GN",
//   orderStatus: "",
//   amount: 10000,
//   currency: "",
//   payUrl: "",
//   payRaw: "",
//   qrCode: "F4630442F4",
//   createTime: "2011-12-03T10:15:30Z",
//   limitReturnUrl: true,
// };

const {
  merchantOrderNo = "",
  orderNo = "",
  amount = 0,
  qrCode = "",
  createTime = "",
} = searchParams;

// 查询充值订单,2s一次轮询
const queryOrderDetail = async () => {
  const res = await checkingOrder({ orderNo: merchantOrderNo });
  // 状态;待充值-WaitingPay; 充值成功-Paid; 充值失败-PayFailed;
  // if (res?.data?.firstFlag) {
  //   // 首充
  //   track2Platform(trackName.Purchase, {
  //     value: +res.data.realAmt,
  //     currency: res.data.currency,
  //     product_catalog_id: res.data.id,
  //   });
  // }

  if (res?.data?.status === "ForcedSuccess" || res?.data?.status === "Paid" || res?.data?.status === "PayFailed") {
    router.push(`/depositoResults?orderNo=${merchantOrderNo}`);

    // if (res?.data?.status !== "PayFailed") {
    //   useWallet().init();
    // }
  }
};

const intervalId = ref<any>(null);

onMounted(() => {
  queryOrderDetail();
  intervalId.value = setInterval(queryOrderDetail, 2000);
});

onBeforeUnmount(() => {
  clearInterval(intervalId.value);
});

// 判断是否已过期
const isExpired = (createTime: string) => {
  // 解析 createTime 为 dayjs 对象
  const creationDate = dayjs(createTime);
  // 计算 expirationDate，增加 30 分钟
  const expirationDate = creationDate.add(30, "minute");
  // 获取当前时间
  const currentDate = dayjs();
  // 判断当前时间是否已经超过 expirationDate
  return currentDate.isAfter(expirationDate);
};
</script>

<style lang="scss" scoped>
.DepositoQRcode {
  --van-nav-bar-background: #ffffff1a;
  --van-nav-bar-icon-color: #ffffff;
  --van-border-width: 0;
  --van-nav-bar-title-text-color: #ffffff;
}
.van-icon {
  color: #ffffff;
}
.msgList {
  li {
    padding-left: 16px;
    position: relative;
    font-size: 13px;
    margin-bottom: 20px;
    &::before {
      content: "";
      display: block;
      width: 4px;
      height: 4px;
      background-color: #fff;
      border-radius: 50%;
      position: absolute;
      left: 0;
      top: 6px;
    }
  }
}
</style>
